(function() {
  var MOBILE_BREAKPOINT = 769;

  function isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function applyDrawerFilters() {
    var drawerForm = document.querySelector('.filter-form[data-filter-form-location="SidebarDrawer"]');
    if (!drawerForm) {
      return;
    }

    var formData = new FormData(drawerForm);
    var searchParams = new URLSearchParams(formData);
    var currentParams = new URLSearchParams(window.location.search);
    var sortBy = currentParams.get('sort_by');
    var view = currentParams.get('view');

    if (sortBy) {
      searchParams.set('sort_by', sortBy);
    }
    if (view) {
      searchParams.set('view', view);
    }

    searchParams.delete('page');
    window.location.search = searchParams.toString();
  }

  function syncViewParamToFilterForms(scope) {
    var currentParams = new URLSearchParams(window.location.search);
    var view = currentParams.get('view');

    scope.querySelectorAll('.filter-form').forEach(function(form) {
      var hiddenInput = form.querySelector('input[data-no-usf-view-param]');

      if (!view) {
        if (hiddenInput) {
          hiddenInput.remove();
        }
        return;
      }

      if (!hiddenInput) {
        hiddenInput = document.createElement('input');
        hiddenInput.type = 'hidden';
        hiddenInput.name = 'view';
        hiddenInput.setAttribute('data-no-usf-view-param', 'true');
        form.appendChild(hiddenInput);
      }

      hiddenInput.value = view;
    });
  }

  function initDrawerApplyButton(scope) {
    scope.querySelectorAll('[data-no-usf-drawer-apply]').forEach(function(button) {
      if (button.dataset.bound === 'true') {
        return;
      }

      button.dataset.bound = 'true';
      button.addEventListener('click', applyDrawerFilters);
    });
  }

  function initDrawerDeferredFiltering(scope) {
    function syncTagActiveState(inputEl) {
      var tagEl = inputEl.closest('li.tag');
      if (!tagEl) {
        return;
      }
      tagEl.classList.toggle('tag--active', !!inputEl.checked);
    }

    scope.querySelectorAll('.filter-form[data-filter-form-location="SidebarDrawer"]').forEach(function(form) {
      if (form.dataset.deferBound === 'true') {
        return;
      }

      form.dataset.deferBound = 'true';
      var blockAutoSubmit = function(evt) {
        if (!isMobile()) {
          return;
        }
        if (evt.target && evt.target.closest('[data-no-usf-drawer-apply]')) {
          return;
        }
        if (evt.target && evt.target.classList && evt.target.classList.contains('tag__input')) {
          syncTagActiveState(evt.target);
        }
        evt.stopImmediatePropagation();
      };

      form.addEventListener('input', blockAutoSubmit, true);
      form.addEventListener('change', blockAutoSubmit, true);

      form.querySelectorAll('.tag__input').forEach(function(inputEl) {
        syncTagActiveState(inputEl);
      });
    });
  }

  function initSwipers(scope) {
    if (typeof Swiper === 'undefined') {
      return;
    }

    scope.querySelectorAll('.js-no-usf-filter-swiper-target').forEach(function(container) {
      var isNoDesktopSwiper = container.classList.contains('no-desktop__swiper');
      if (isNoDesktopSwiper && !isMobile()) {
        if (container.noUsfSwiper && typeof container.noUsfSwiper.destroy === 'function') {
          container.noUsfSwiper.destroy(true, true);
          container.noUsfSwiper = null;
        }

        var desktopSkipScrollbar = container.querySelector('.swiper-scrollbar');
        if (desktopSkipScrollbar) {
          desktopSkipScrollbar.remove();
        }
        return;
      }

      if (container.noUsfSwiper && typeof container.noUsfSwiper.destroy === 'function') {
        container.noUsfSwiper.destroy(true, true);
      }

      var scrollbar = container.querySelector('.swiper-scrollbar');
      if (!scrollbar) {
        scrollbar = document.createElement('div');
        scrollbar.className = 'swiper-scrollbar';
        container.appendChild(scrollbar);
      }

      var mobileSlides = parseFloat(container.dataset.mobileSlides || '2.5');
      var desktopSlides = parseFloat(container.dataset.desktopSlides || '3');
      var groupEl = container.closest('.no-usf-filter-group');
      var prevButton = groupEl ? groupEl.querySelector('.no-usf-filter-group__swiper-prev') : null;
      var nextButton = groupEl ? groupEl.querySelector('.no-usf-filter-group__swiper-next') : null;
      var hasNavigation = !!(prevButton && nextButton);

      var swiperOptions = {
        slidesPerView: mobileSlides,
        spaceBetween: 8,
        freeMode: true,
        observer: true,
        observeParents: true,
        watchOverflow: true,
        scrollbar: {
          el: scrollbar,
          draggable: true
        },
        breakpoints: {
          769: {
            slidesPerView: desktopSlides,
            spaceBetween: 10,
            freeMode: false
          }
        }
      };

      if (hasNavigation) {
        swiperOptions.navigation = {
          prevEl: prevButton,
          nextEl: nextButton
        };
      }

      container.noUsfSwiper = new Swiper(container, swiperOptions);
    });
  }

  function parsePriceInput(value) {
    var normalized = String(value || '').trim().replace(/[^\d,.\-]/g, '');
    if (!normalized) {
      return null;
    }
    if (normalized.indexOf(',') > -1 && normalized.indexOf('.') === -1) {
      normalized = normalized.replace(',', '.');
    } else {
      normalized = normalized.replace(/,/g, '');
    }
    var parsed = parseFloat(normalized);
    return Number.isFinite(parsed) ? parsed : null;
  }

  function applyPriceInputValue(input, mode) {
    var rangeEl = input.closest('.price-range');
    if (!rangeEl) {
      return;
    }

    var sliderEl = rangeEl.querySelector('.price-range__slider');
    if (!sliderEl || !sliderEl.noUiSlider) {
      return;
    }

    var values = sliderEl.noUiSlider.get();
    var currentMin = parseFloat(values[0]);
    var currentMax = parseFloat(values[1]);
    var rangeMin = parseFloat(rangeEl.dataset.min);
    var rangeMax = parseFloat(rangeEl.dataset.max);
    var minInput = rangeEl.querySelector('.price-range__input-min');
    var maxInput = rangeEl.querySelector('.price-range__input-max');

    if (!Number.isFinite(rangeMin)) {
      rangeMin = 0;
    }
    if (!Number.isFinite(rangeMax)) {
      rangeMax = Number.isFinite(currentMax) ? currentMax : 0;
    }
    if (!Number.isFinite(currentMin)) {
      currentMin = rangeMin;
    }
    if (!Number.isFinite(currentMax)) {
      currentMax = rangeMax;
    }

    var minValue = parsePriceInput(minInput.value);
    var maxValue = parsePriceInput(maxInput.value);

    if (minValue === null) {
      minValue = Number.isFinite(currentMin) ? currentMin : rangeMin;
    }
    if (maxValue === null) {
      maxValue = Number.isFinite(currentMax) ? currentMax : rangeMax;
    }

    minValue = Math.max(rangeMin, Math.min(minValue, rangeMax));
    maxValue = Math.max(rangeMin, Math.min(maxValue, rangeMax));

    if (mode === 'min' && minValue > maxValue) {
      minValue = maxValue;
    }
    if (mode === 'max' && maxValue < minValue) {
      maxValue = minValue;
    }

    if (!Number.isFinite(minValue) || !Number.isFinite(maxValue)) {
      return;
    }

    sliderEl.noUiSlider.set([minValue, maxValue]);
    minInput.value = minValue;
    maxInput.value = maxValue;

    var formEl = rangeEl.closest('.filter-form');
    if (!formEl) {
      return;
    }

    if (isMobile() && formEl.dataset.filterFormLocation === 'SidebarDrawer') {
      return;
    }

    var formData = new FormData(formEl);
    var searchParams = new URLSearchParams(formData);
    var currentParams = new URLSearchParams(window.location.search);
    var view = currentParams.get('view');
    if (view) {
      searchParams.set('view', view);
    }
    searchParams.delete('page');
    window.location.search = searchParams.toString();
  }

  function initPriceInputs(scope) {
    scope.querySelectorAll('.no-usf-price-range__input').forEach(function(input) {
      if (input.dataset.bound === 'true') {
        return;
      }

      input.dataset.bound = 'true';
      var mode = input.classList.contains('price-range__input-min') ? 'min' : 'max';

      input.addEventListener('input', function(evt) {
        if (evt.isTrusted) {
          evt.stopPropagation();
        }
      });

      input.addEventListener('keydown', function(evt) {
        if (evt.key !== 'Enter') {
          return;
        }
        evt.preventDefault();
        applyPriceInputValue(input, mode);
      });

      input.addEventListener('blur', function() {
        applyPriceInputValue(input, mode);
      });
    });
  }

  /* == No USF overhidden controls 2026-04-20 B == */
  function initOverhiddenLists(scope) {
    var COLLAPSED_VISIBLE_COUNT = 10;

    function syncOverhiddenItemMaxHeight(listEl) {
      var listParentEl = listEl.parentElement;
      if (!listParentEl) {
        return;
      }

      // Sync max height of overhidden items
      var maxHeight = 0;
      listEl.querySelectorAll('li.tag').forEach(function(itemEl) {
        if (
          itemEl.classList.contains('hide') ||
          itemEl.classList.contains('no-usf-overhidden-item-hidden') ||
          itemEl.classList.contains('no-usf-overhidden-hidden')
        ) {
          return;
        }
        maxHeight = Math.max(maxHeight, itemEl.offsetHeight || 0);
      });

      if (maxHeight > 0) {
        listParentEl.style.setProperty('--no-usf-overhidden-item-max-height', maxHeight + 'px');
      } else {
        listParentEl.style.removeProperty('--no-usf-overhidden-item-max-height');
      }
    }

    function triggerSyncOverhiddenItemMaxHeight(listEl) {
      window.requestAnimationFrame(function() {
        syncOverhiddenItemMaxHeight(listEl);
      });
    }

    function getFilterItems(listEl) {
      return Array.prototype.slice.call(listEl.querySelectorAll('.no-usf-filter-value:not(.no-usf-overhidden-control)'));
    }

    function getVisibleFilterItems(items) {
      return items.filter(function(itemEl) {
        return !itemEl.classList.contains('hide');
      });
    }

    // Set expanded state of overhidden list
    function setExpandedState(listEl, expanded) {
      var allItems = getFilterItems(listEl);
      var visibleItems = getVisibleFilterItems(allItems);
      var moreControl = listEl.querySelector('[data-overhidden-control="more"]');
      var lessControl = listEl.querySelector('[data-overhidden-control="less"]');

      if (!moreControl || !lessControl || visibleItems.length <= COLLAPSED_VISIBLE_COUNT) {
        allItems.forEach(function(itemEl) {
          itemEl.classList.remove('no-usf-overhidden-item-hidden');
        });
        if (moreControl) {
          moreControl.classList.add('no-usf-overhidden-hidden');
        }
        if (lessControl) {
          lessControl.classList.add('no-usf-overhidden-hidden');
        }
        listEl.removeAttribute('data-overhidden-expanded');
        triggerSyncOverhiddenItemMaxHeight(listEl);
        return;
      }

      var collapsedStartIndex = COLLAPSED_VISIBLE_COUNT;
      visibleItems.forEach(function(itemEl, index) {
        var shouldHide = !expanded && index >= collapsedStartIndex;
        itemEl.classList.toggle('no-usf-overhidden-item-hidden', shouldHide);
      });

      var anchorItem = visibleItems[collapsedStartIndex];
      if (anchorItem) {
        listEl.insertBefore(moreControl, anchorItem);
      } else {
        listEl.appendChild(moreControl);
      }
      listEl.appendChild(lessControl);

      moreControl.classList.toggle('no-usf-overhidden-hidden', expanded);
      lessControl.classList.toggle('no-usf-overhidden-hidden', !expanded);
      if (expanded) {
        listEl.setAttribute('data-overhidden-expanded', 'true');
      } else {
        listEl.removeAttribute('data-overhidden-expanded');
      }
      triggerSyncOverhiddenItemMaxHeight(listEl);
    }

    // Initialize overhidden lists
    scope.querySelectorAll('[data-is-overhidden-element]').forEach(function(listEl) {
      if (!listEl.dataset.overhiddenBound) {
        listEl.dataset.overhiddenBound = 'true';

        var moreButton = listEl.querySelector('[data-overhidden-show-more]');
        if (moreButton) {
          moreButton.addEventListener('click', function(evt) {
            evt.preventDefault();
            setExpandedState(listEl, true);
          });
        }

        var lessButton = listEl.querySelector('[data-overhidden-show-less]');
        if (lessButton) {
          lessButton.addEventListener('click', function(evt) {
            evt.preventDefault();
            setExpandedState(listEl, false);
          });
        }
      }

      var expanded = listEl.getAttribute('data-overhidden-expanded') === 'true';
      setExpandedState(listEl, expanded);
    });
  }
  /* == No USF overhidden controls 2026-04-20 E == */

  function initNoUsfFilters(scope) {
    syncViewParamToFilterForms(scope);
    initSwipers(scope);
    initPriceInputs(scope);
    initDrawerApplyButton(scope);
    initDrawerDeferredFiltering(scope);
    initOverhiddenLists(scope);
  }

  document.addEventListener('DOMContentLoaded', function() {
    initNoUsfFilters(document);
  });

  document.addEventListener('collection:reloaded', function() {
    initNoUsfFilters(document);
  });
})();
